import { supplierApiNm } from "pages/Menu4/Supplier/constant"
import { subcontractApiNm } from "constants/subcontractConstant"
import { jobOrderApiNm } from "constants/jobOrderConstant"
import { numberFormat } from "utils"
import { toBahtText } from "utils/toBahtText"
import { branchNoText } from "utils/branchNoText"
import { printWht } from "branch/functions/printWht"
import { printWhtNoAgent } from "branch/functions/printWhtNoAgent"
import { isPrintUserWht } from "branch/constant/IsPrintUserWht"

export const getDataAndPrintWht = async ({ ax, dialogData, companyData, updLnkSiteAbbr, user }) => {
  let receiver = { name: "", addr: "", taxId: "" }
  let jobData = [{ name: "", addr: "", taxId: "" }]

  // Handle SupId (supplier) or ScId (subcontract)
  if (dialogData.SupId) {
    const postData = {
      SupId: dialogData.SupId,
      UpdLnkSiteAbbr: updLnkSiteAbbr
    }
    const value = await ax.post(supplierApiNm.getSupplier, postData)
    if (value.data && value.data.length === 1) {
      const data = value.data[0]
      receiver = {
        name: data.Name,
        addr: data.Addr,
        taxId: data.TaxId,
        brchNo: data.BrchNo
      }
      receiver.addr = `${receiver.addr} ${receiver.brchNo >= 0 ? branchNoText(receiver.name, receiver.brchNo) : ""}`
    }
  } else if (dialogData.ScId) {
    const value = await ax.post(subcontractApiNm.getSubcontract, { ScId: dialogData.ScId })
    if (value.data && value.data.length === 1) {
      const data = value.data[0]
      receiver = {
        name: data.Name,
        addr: data.Addr,
        taxId: data.TaxId,
        brchNo: data.BrchNo
      }
      receiver.addr = `${receiver.addr} ${receiver.brchNo >= 0 ? branchNoText(receiver.name, receiver.brchNo) : ""}`
    }
  }

  console.log("dialogData in getDataAndPrintWht", dialogData)
  if ((dialogData.JobOrdId || dialogData.JobOrdIds) && ["A", "C"].includes(dialogData.WhtPayrTyp)) {
    const postData = {
      JobOrdId: dialogData.JobOrdId,
      JobOrdIds: dialogData.JobOrdIds,
      UpdLnkSiteAbbr: updLnkSiteAbbr
    }
    const value = await ax.post(jobOrderApiNm.getDataForPrintWht, postData)
    if (value.data && value.data.length > 0) {
      // const data = value.data[0]
      jobData = value.data.map(data =>({
        name: data.JobData.RcptNm,
        addr: `${data.JobData.RcptAddr} ${data.JobData.RcptBrchNo >= 0 ? branchNoText(data.JobData.RcptNm, data.JobData.RcptBrchNo) : ""}`,
        taxId: data.JobData.RcptTaxId,
        joData: data
      }))
    }
  }

  const ownAddr = { name: companyData.NameTH, addr: companyData.AddrTH, taxId: companyData.TaxId }
  const amnt = (+dialogData.Amnt) / (1 + +dialogData.VatPrct / 100)
  const wht = amnt * +dialogData.WhtPrct / 100

  const whtData = {
    receiver: receiver,
    amnt: numberFormat(amnt),
    wht: numberFormat(wht),
    whtText: toBahtText(wht),
    whtTyp: dialogData.WhtTypId,
    whtTypOthTxt: dialogData.WhtTypOthTxt || "",
    UsrNm: `${user.FName} ${user.LName}`,
    DocDte: dialogData.DocDte || dialogData.PCItmTm || dialogData.PayTm
  }

  if (["O", "C"].includes(dialogData.WhtPayrTyp)) {
    if (dialogData.WhtPayrTyp === "O") {
      whtData.payers = [ownAddr]
    } else {
      whtData.payers = jobData
    }
    whtData.agent = { name: "", addr: "", taxId: "" }
    printWhtNoAgent({ whtData, joData: dialogData, isPrintUser:  isPrintUserWht.isPrintUser, isPrintDate: isPrintUserWht.isPrintDate })
  } else {
    whtData.payers = jobData
    whtData.agent = ownAddr
    printWht({ whtData, joData: dialogData, isPrintUser: isPrintUserWht.isPrintUser, isPrintDate: isPrintUserWht.isPrintDate })
  }
}


